import {
  GET_LEGALITYDOCUMENT,
  GET_LEGALITYDOCUMENT_SUCCESS,
  GET_LEGALITYDOCUMENT_FAIL,
  DELETE_LEGALITYDOCUMENT,
  DELETE_LEGALITYDOCUMENT_SUCCESS,
  DELETE_LEGALITYDOCUMENT_FAIL,
  UPDATE_LEGALITYDOCUMENT,
  UPDATE_LEGALITYDOCUMENT_SUCCESS,
  UPDATE_LEGALITYDOCUMENT_FAIL,
  ADD_NEW_LEGALITYDOCUMENT,
  ADD_LEGALITYDOCUMENT_SUCCESS,
  ADD_LEGALITYDOCUMENT_FAIL,
  LEGALITYDOCUMENT_LOADING,
  LEGALITYDOCUMENT_RESET
} from "./actionType";

export const resetLegalityDocumentState = (actionType) => ({
  type: LEGALITYDOCUMENT_RESET,
  payload: { actionType },
});

export const getLegalityDocumentSuccess = (actionType, data) => ({
  type: GET_LEGALITYDOCUMENT_SUCCESS,
  payload: { actionType, data },
});

export const getLegalityDocumentFail = (actionType, error) => ({
  type: GET_LEGALITYDOCUMENT_FAIL,
  payload: { actionType, error },
});

export const getLegalityDocument = data => ({
  type: GET_LEGALITYDOCUMENT,
  payload: data,
});

export const getLegalityDocumentLoading = () => ({
  type: LEGALITYDOCUMENT_LOADING
});

export const deleteLegalityDocument = data => ({
  type: DELETE_LEGALITYDOCUMENT,
  payload: data,
});

export const deleteLegalityDocumentSuccess = data => ({
  type: DELETE_LEGALITYDOCUMENT_SUCCESS,
  payload: data,
});

export const deleteLegalityDocumentFail = error => ({
  type: DELETE_LEGALITYDOCUMENT_FAIL,
  payload: error,
});

export const updateLegalityDocument = data => ({
  type: UPDATE_LEGALITYDOCUMENT,
  payload: data,
});

export const updateLegalityDocumentFail = error => ({
  type: UPDATE_LEGALITYDOCUMENT_FAIL,
  payload: error,
});

export const updateLegalityDocumentSuccess = data => ({
  type: UPDATE_LEGALITYDOCUMENT_SUCCESS,
  payload: data,
});

export const addNewLegalityDocument = data => ({
  type: ADD_NEW_LEGALITYDOCUMENT,
  payload: data,
});

export const addLegalityDocumentSuccess = data => ({
  type: ADD_LEGALITYDOCUMENT_SUCCESS,
  payload: data,
});

export const addLegalityDocumentFail = error => ({
  type: ADD_LEGALITYDOCUMENT_FAIL,
  payload: error,
});